export default __webpack_public_path__ + "static/media/Baccialegno.a6d0ad8e.jpg";